import React from 'react';

import { ThemeModeEnum } from '../../constants/App';

interface Props {
    alignment: string;
    isVisible: boolean;
    style: React.CSSProperties;
    isSyncActive: boolean;
    themeMode: ThemeModeEnum;
    isFullWidth: boolean;
}
export default class Sidebar extends React.PureComponent<Props, {}> {
    static defaultProps = {
        themeMode: ThemeModeEnum.LIGHT,
        isFullWidth: false,
    };

    renderSyncBlocker = (): React.ReactNode => {
        const { isSyncActive } = this.props;

        if (!isSyncActive) {
            return null;
        }

        return <div className="ct-sidebar__sync-blocker" />;
    };

    render() {
        const { children, alignment, isVisible, style, themeMode, isFullWidth } = this.props;

        let classNames: Array<string> = [
            'ct-sidebar',
            `ct-sidebar--${alignment}`,
            `ct-sidebar--${isVisible ? 'visible' : 'hidden'}`,
        ];
        if (isFullWidth) {
            classNames.push('ct-sidebar--is-full-width');
        }
        if (themeMode === ThemeModeEnum.DARK) {
            classNames.push('ct-sidebar--is-dark-mode');
        }
        return (
            <div className={classNames.join(' ')} style={style}>
                <div className="ct-sidebar__inner">{children}</div>
                {this.renderSyncBlocker()}
            </div>
        );
    }
}
